import { isNil } from '~/utilities/type-guards';
import type { Speaker } from '~/graphql';
import { useSpeakersQuery } from './__gql/Speakers.gql.gen';

type UseSpeakersProps = {
  mediaHashedId: string;
};

type UseSpeakersResult = {
  speakers: Speaker[];
  loading: boolean;
};

export const useSpeakers = ({ mediaHashedId }: UseSpeakersProps): UseSpeakersResult => {
  const { data, loading, error } = useSpeakersQuery({
    variables: { mediaHashedId },
    fetchPolicy: 'cache-and-network',
  });

  if (loading) {
    return {
      speakers: [],
      loading: true,
    };
  }

  if (error) {
    return {
      speakers: [],
      loading: false,
    };
  }

  if (isNil(data?.anonymousMedia?.transcriptSpeakers)) {
    return {
      speakers: [],
      loading: false,
    };
  }

  return {
    speakers: data.anonymousMedia.transcriptSpeakers as Speaker[],
    loading: false,
  };
};
